import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@magnetic/flex';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import NatsClient from '../../../../store/natsclient';
import CountsOverview from '../components/counts-overview';
import Header from '../components/header';
import FooterBrand from '../components/footer-brand';
import FloorTelemetry from '../components/floor-telemetry';
import FloorSelectorCard from '../components/floor-selector-card';
import LanguagePickerCard from '../components/language-picker-card';
import MapComponent from '../components/map/index';
import FloorLayout from './floor-layout';
import { MapProvider } from './MapContext';
import WebGLModal from './web-gl-modal';
import { closeRoomDetailsPopup, } from '../components/room-details-popup';
import RoomDetailsPopup2 from '../components/room-details-popup-2.1';
import { setViewType } from '../../../../store/authslice';
import { getSelectedLocation, setSelectedLocation, } from '../../redux/spaces-slice';
import { checkIfModelRequired, getRoomSearchPopUpOpen, getUIState, setRoomDetailsPopUp, setRoomFinderOpen, setRoomSearchPopUp, setResetWidgets, } from '../../../../store/uislice';
import { store } from '../../../../store/store';
import { getOccupancyStatus, resolveActiveFloorLocation, } from '../util';
import { getLocation, selectFloorById, getRoomAnalytics, } from '../../redux/spaces-slice';
import HowToUseThis2 from '../components/how-to-use-this-2.1';
import { getContext } from '../../redux/spaces-slice';
import './index.scss';
import FloorTimeDisplay from '../components/time-display';
import POIsPanel from '../components/pois-panel';
import QRFrame from '../components/qr-frame';
import { resolveShowWayFinding } from '../util/show-path-finding';
import MapContainer from '../components/map/map-container.styled';
import { invokeRichMapMethod } from '../components/map/rich-map';
import InactivityPopup21 from '../components/inactive-timeout-2.1';
import { RoomSearchPopupNew } from '../components/room-search-popup-new';
import { isLanguagePickerEnabled } from '../../../../utils/language-picker';
const BrandLogoContainer = styled.div `
  width: 10.3vw;
  img {
    width: 100%;
    height: 100%;
  }
`;
const TimeContainer = styled.div `
  margin-top: 1.1vw;
  padding: 0;
  border-radius: 0.6vw;
  position: fixed;
  right: 13vw;
  top: 0.8vw;
  z-index: 2;

  @media (orientation: portrait) {
    right: clamp(8.5rem, 20vw, 12rem);
    top: 1.1vw;
  }

  @media (max-width: 768px) and (orientation: portrait) {
    right: 8rem;
    top: 0.9rem;
  }
`;
const FloorInfoContainer = styled(Flex) `
  box-shadow: 0px 2px 0px 0px rgba(52, 56, 62, 1) inset;
  border-image-source: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0) 33.63%,
    #4c535b 100%
  );
`;
const CountsOverviewContainer = styled.div `
  position: fixed;
  top: 0.95vw;
  left: 50%;
  transform: translateX(-50%);
  /* Baseline size (~10% narrower than the previous min(23vw, 30rem)), but grow
     to fit the selector's tab labels when a language needs more room (instead of
     clipping). Capped so it never spans the whole screen. This base rule is what
     both landscape (1920) and kiosk portrait (1080) use, so the fix applies to
     both. */
  width: fit-content;
  min-width: min(20.7vw, 27rem);
  max-width: min(92vw, 46rem);
  z-index: 2;

  @media (max-width: 1024px) {
    top: 1.2rem;
    width: min(calc(100vw - 26rem), 26rem);
  }

  @media (max-width: 768px) {
    top: 5.8rem;
    left: 1rem;
    right: 1rem;
    transform: none;
    width: auto;
  }
`;
const FloorView = ({ id }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const dispatch = useDispatch();
    const locationData = useSelector(getLocation);
    const contextInfo = useSelector(getContext);
    const { floorLocationId, floorLocationData } = resolveActiveFloorLocation(locationData, contextInfo, id !== null && id !== void 0 ? id : '');
    const floorAnalyticsCurrentFloor = useSelector((state) => selectFloorById(state, floorLocationId !== null && floorLocationId !== void 0 ? floorLocationId : ''));
    const airQuality = (_a = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.airQuality) !== null && _a !== void 0 ? _a : null;
    const ambientTemp = (_b = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.ambientTemp) !== null && _b !== void 0 ? _b : null;
    const co2 = (_c = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.co2) !== null && _c !== void 0 ? _c : null;
    const peopleCount = (_d = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.peopleCount) !== null && _d !== void 0 ? _d : null;
    const capacity = (_e = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.capacity) !== null && _e !== void 0 ? _e : null;
    const relativeHumidity = (_f = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.relativeHumidity) !== null && _f !== void 0 ? _f : null;
    const occupancyStatus = getOccupancyStatus(peopleCount, capacity);
    const appConfigFloor = (_g = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _g === void 0 ? void 0 : _g.floor;
    const showAirQuality = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showAirQuality;
    const showCO2 = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showCO2;
    const showFloorOccupancy = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showFloorOccupancy;
    const showHumidity = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showHumidity;
    const showTemperature = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showTemperature;
    const [isFirstPopup, setIsFirstPopup] = useState(true);
    const interactive = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.interactive;
    const showPOIs = (_j = (_h = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _h === void 0 ? void 0 : _h.floor) === null || _j === void 0 ? void 0 : _j.showPOI;
    const showLanguagePicker = isLanguagePickerEnabled(contextInfo);
    const shouldShowWhereAmI = 'isWhereAmIEnabled' in contextInfo &&
        (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWhereAmIEnabled) !== null
        ? contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWhereAmIEnabled
        : (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId) !== null;
    const isWayFindingEnabled = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWayFindingEnabled;
    const { tenantId, buildingLocationId, zoom, mapCenterLatLng, pitch, bearing, modelWithScreen = true, deviceLatLng, rotateAngle, deviceLocationId, } = contextInfo;
    const buildingName = locationData === null || locationData === void 0 ? void 0 : locationData.name;
    const floorNumber = floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.floorNumber;
    const floorName = (floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.shortName) || (floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.name);
    // Wayfinding QR display for the CURRENT floor, honoring the hierarchical LH
    // `showWayFinding` flag (tenant base = `isWayFindingEnabled` -> building ->
    // floor). Only explicit booleans disable; absent/null inherit, so the floor
    // "navigate on phone" widget behaves exactly as before when the flag is unset.
    const showWayFindingForFloor = resolveShowWayFinding({
        location: locationData,
        floorNumber: Number(floorNumber),
        tenantWayFindingEnabled: Boolean(isWayFindingEnabled),
    });
    const deviceLocationFloorNumber = (_l = (_k = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _k === void 0 ? void 0 : _k.find((child) => child.id === deviceLocationId)) === null || _l === void 0 ? void 0 : _l.floorNumber;
    const floorNumberIdMap = {};
    // TODO Optimize below subscription
    useEffect(() => {
        var _a;
        if ((locationData === null || locationData === void 0 ? void 0 : locationData.id) && floorLocationId) {
            console.log('Initiating subscriptions  in floor');
            const subject = `signageAnalytical.${locationData.id}.${floorLocationId}.*`;
            console.log('Floor view subject :: ', subject);
            NatsClient.subscribe([subject]);
            for (const floorNumber of (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : []) {
                floorNumberIdMap[floorNumber.floorNumber] = floorNumber.id;
            }
        }
    }, [floorLocationId, locationData.id]);
    useEffect(() => {
        const webGL = (() => {
            try {
                const canvas = document.createElement('canvas');
                return !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
            }
            catch (e) {
                return false;
            }
        })();
        setHasWebGLSupport(webGL);
    }, []);
    const content = () => (_jsxs(Flex, Object.assign({ style: {
            gap: '1vw',
            width: '99.2vw',
        } }, { children: [_jsx(FloorSelectorCard, { building: buildingName, floor: floorName, selectFloor: (floorId) => {
                    if (String(floorId).toLowerCase() === 'all') {
                        dispatch(setSelectedLocation(''));
                    }
                    else {
                        dispatch(setSelectedLocation(String(floorId)));
                    }
                } }), _jsx(CountsOverviewContainer, { children: _jsx(CountsOverview, { floorId: floorLocationId }) }), _jsx(TimeContainer, { children: _jsx(FloorTimeDisplay, {}) }), _jsx(HowToUseThis2, {}), _jsx(FloorTelemetry, { showAirQuality: showAirQuality, showCO2: showCO2, showFloorOccupancy: showFloorOccupancy, showHumidity: showHumidity, showTemperature: showTemperature, airQuality: airQuality, ambientTemp: ambientTemp, co2: co2, occupancyStatus: occupancyStatus, relativeHumidity: relativeHumidity })] })));
    const mapDetails = {
        map: {
            tenantId: tenantId,
            buildingId: buildingLocationId,
            zoom: zoom,
            long: mapCenterLatLng[1],
            lat: mapCenterLatLng[0],
            pitch: pitch,
            bearing: bearing,
            floorNumber: Number(floorNumber),
            floorLocation: floorNumber,
        },
        device: {
            modelWithScreen: modelWithScreen,
            deviceLocation: deviceLocationFloorNumber,
            long: deviceLatLng && deviceLatLng[1],
            lat: deviceLatLng && deviceLatLng[0],
            xAngle: rotateAngle && rotateAngle[0],
            yAngle: rotateAngle && rotateAngle[1],
            zAngle: rotateAngle && rotateAngle[2],
        },
    };
    const [hasWebGLSupport, setHasWebGLSupport] = useState(true);
    const showRoomDetailsPopup = (richMapId) => {
        store.dispatch(setRoomDetailsPopUp({ payload: richMapId }));
    };
    const getRoomAvailabilityForHighlighting = (roomsData) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const roomAvailability = {};
        for (const room in roomsData) {
            if (!roomsData[room] || !((_a = roomsData[room]) === null || _a === void 0 ? void 0 : _a.availability))
                continue;
            const availabilityStatus = ((_b = roomsData[room]) === null || _b === void 0 ? void 0 : _b.availability) === 'noData'
                ? 'Unknown'
                : (_c = roomsData[room]) === null || _c === void 0 ? void 0 : _c.availability;
            roomAvailability[room] = {
                availability: availabilityStatus,
                richMapId: (_d = roomsData[room]) === null || _d === void 0 ? void 0 : _d.richMapId,
                level: ((_g = (_f = (_e = roomsData[room]) === null || _e === void 0 ? void 0 : _e.level) === null || _f === void 0 ? void 0 : _f.toLowerCase) === null || _g === void 0 ? void 0 : _g.call(_f)) || 'room',
            };
        }
        return roomAvailability;
    };
    // TODO: Till individual desk updates are not being received, use this implementation
    // const getDeskAvailabilityForHighlighting = (deskInfo) => {
    //   if (!deskInfo) return {};
    //   const roomAvailability = {};
    //   const statuses = ['available', 'occupied', 'booked'];
    //   for (const status of statuses) {
    //     for (const desk of deskInfo[status]) {
    //       roomAvailability[desk] = {
    //         availability: status,
    //         richMapId: desk,
    //       };
    //     }
    //   }
    //   return roomAvailability;
    // };
    const roomsData = useSelector(getRoomAnalytics);
    // Memoize so an unrelated re-render (e.g. opening the room details popup) does
    // not produce a brand-new object reference. A new reference would re-trigger
    // MapComponent's highlight effect, which schedules a map-wide feature-state
    // refresh that repaints the GL map mid camera-animation and causes a stutter.
    const roomAvailability = useMemo(() => getRoomAvailabilityForHighlighting(roomsData), [roomsData]);
    // const deskAvailability = getDeskAvailabilityForHighlighting(
    //   floorAnalyticsCurrentFloor?.availabilityInfo?.deskInfo
    // );
    const showRoomSearchPopup = useSelector(getRoomSearchPopUpOpen);
    /***********inactivity-popup-logic***********/
    const INACTIVITY_TIMEOUT = 240; // In seconds
    const RESET_TIMER = 15; // In seconds
    const CHECK_INTERVAL = 10; // In seconds, lesser the check interval, higher the accuracy, but more freq checking of (currenTime - lastTouch) diff
    const UPDATE_LAST_TOUCH = 10; // In seconds, to update last touch when dirty itself is false, (so need to render popup)
    const [showInactivityPopup, setShowInactivityPopup] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const lastTouchRef = useRef(null);
    const intervalCheckerRef = useRef(null);
    const selectedFloor = useSelector(getSelectedLocation);
    const isCurrViewTypeBuilding = !selectedFloor || selectedFloor.trim() === '';
    const defaultFloorId = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.defaultFloorId;
    const updateLastTouch = () => {
        lastTouchRef.current = Date.now();
        setIsDirty(true);
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (!isDirty) {
                lastTouchRef.current = Date.now();
            }
        }, UPDATE_LAST_TOUCH * 1000);
        return () => clearInterval(intervalId);
    }, [isDirty]);
    useEffect(() => {
        updateLastTouch();
        setShowInactivityPopup(false);
        window.addEventListener('mousemove', updateLastTouch);
        window.addEventListener('touchmove', updateLastTouch);
        intervalCheckerRef.current = setInterval(() => {
            // Interval checker runs every 'CHECK_INTERVAL' seconds to perform check on lastTouch update
            if (lastTouchRef.current &&
                Date.now() - lastTouchRef.current >= INACTIVITY_TIMEOUT * 1000)
                setShowInactivityPopup(true);
        }, CHECK_INTERVAL * 1000);
        return () => {
            // cleanup on dismount
            if (intervalCheckerRef.current)
                clearInterval(intervalCheckerRef.current);
            window.removeEventListener('mousemove', updateLastTouch);
            window.removeEventListener('touchmove', updateLastTouch);
        };
    }, [isCurrViewTypeBuilding]);
    const deviceLocationIdIsInChildren = (deviceLocationId) => {
        return locationData === null || locationData === void 0 ? void 0 : locationData.children.some((child) => (child === null || child === void 0 ? void 0 : child.id) === deviceLocationId);
    };
    deviceLocationIdIsInChildren(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId);
    const resetViewHandler = () => {
        const isBuilding = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) === 'building';
        // If default floor is enabled, go to default floor
        if (defaultFloorId) {
            dispatch(setSelectedLocation(defaultFloorId));
        }
        // If Where-Am-I is enabled, go to where-am-I floor
        if ((contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId) &&
            shouldShowWhereAmI &&
            deviceLocationIdIsInChildren(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId)) {
            // If current floor is not the Where-Am-I floor, switch to Where-Am-I floor
            closeRoomDetailsPopup();
            // if (id !== deviceLocationId)
            if (!invokeRichMapMethod('prevNavigationLevel')) {
                invokeRichMapMethod('exitNavigation');
            }
            setTimeout(() => {
                store.dispatch(checkIfModelRequired());
                invokeRichMapMethod('reset');
            }, 1000);
            dispatch(setSelectedLocation(deviceLocationId));
            // Else just reset view
        }
        // If Where-Am-I is disabled
        else {
            // If building view signage and default floor not set up, go to building view
            if (isBuilding && !defaultFloorId) {
                dispatch(setSelectedLocation(''));
                dispatch(setViewType('building'));
            }
            else {
                // If floor view signage, reset floor view
                closeRoomDetailsPopup();
                invokeRichMapMethod('reset');
            }
        }
        setShowInactivityPopup(false);
        setIsDirty(false);
        lastTouchRef.current = Date.now();
        invokeRichMapMethod('reset');
        store.dispatch(setResetWidgets({ payload: Date.now() }));
        store.dispatch(setRoomFinderOpen({ payload: false }));
        store.dispatch(setRoomSearchPopUp({ payload: false }));
    };
    const continueHandler = () => {
        setShowInactivityPopup(false);
        lastTouchRef.current = Date.now();
    };
    /*******************************************/
    const richMapId = (_m = useSelector(getUIState)) === null || _m === void 0 ? void 0 : _m.popupRichMapID;
    // if (!floorLocationId) {
    //   return <div style={{ width: '100%', height: '100%' }} />; // or a placeholder
    // }
    if (!contextInfo || Object.keys(contextInfo).length === 0) {
        dispatch(setViewType('building'));
        return null;
    }
    return (_jsxs(FloorLayout, { children: [showInactivityPopup && isDirty && !isCurrViewTypeBuilding && (_jsx(InactivityPopup21, { maxTime: RESET_TIMER, continueHandler: continueHandler, resetViewHandler: resetViewHandler })), !hasWebGLSupport && _jsx(WebGLModal, {}), hasWebGLSupport && (_jsxs(MapProvider, { children: [_jsxs("div", Object.assign({ style: { zIndex: '', position: 'fixed' } }, { children: [_jsx(MapContainer, { id: "map-v2", className: "map-container", style: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    zIndex: 0,
                                    width: '100vw',
                                    height: '100vh',
                                } }), _jsx(MapComponent, { mapDetails: mapDetails, showRoomDetailsPopup: showRoomDetailsPopup, roomAvailability: roomAvailability, deskStatus: {}, showPOI: showPOIs, 
                                // Pause the map's (occluded) highlight passes while the search
                                // overlay is open so they don't compete with the list's scroll.
                                isSearchOpen: showRoomSearchPopup })] })), _jsxs("div", Object.assign({ className: "left-panel" }, { children: [showWayFindingForFloor && _jsx(QRFrame, {}), interactive && showPOIs !== false && (_jsx(POIsPanel, { floorNumber: Number(floorNumber) }))] })), showRoomSearchPopup && (_jsx(RoomSearchPopupNew, { floorId: floorLocationId, onClose: () => store.dispatch(setRoomSearchPopUp({ payload: false })) }))] })), _jsx(Header, { children: content() }), showLanguagePicker && _jsx(LanguagePickerCard, {}), _jsx(FooterBrand, {}), richMapId && _jsx(RoomDetailsPopup2, { floorId: floorLocationId })] }));
};
export default FloorView;
